(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // sticky header
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;

    // Add header-top class when window viewport is at top of page...
    if (currentScrollPos > 100) {
      document.querySelector('header').classList.remove('header--top');
    } else {
      document.querySelector('header').classList.add('header--top');
    }

    // hide and show based on scroll direction...
    if ((prevScrollpos > currentScrollPos) || (currentScrollPos < 100)) {
      document.querySelector('header').classList.remove('hide');
    } else {
      document.querySelector('header').classList.add('hide');
    }
    prevScrollpos = currentScrollPos;
  };

  // Mobile nav menu toggle

  var header = document.querySelector('header');
  var mobileMenuToggle = document.getElementById('mobile-menu-toggle');

  const disableBodyScroll = () => {
    document.body.style.overflow = 'hidden';
  };

  const clearScrollLock = () => {
    document.body.style.overflow = 'auto';
  };

  function toggleMenu() {
    header.classList.contains('menu-open') ? clearScrollLock() : disableBodyScroll();
    header.classList.toggle('menu-open');
    mobileMenuToggle.setAttribute(
      'aria-expanded',
      `${(mobileMenuToggle.getAttribute('aria-expanded') !== 'true').toString()}`
    );
    mobileMenuToggle.innerText = header.classList.contains('menu-open') ? 'CLOSE' : 'MENU';
  }

  mobileMenuToggle.addEventListener('click', toggleMenu);

  // Close the menu when a link is clicked
  var navLinks = document.querySelectorAll('#menu-links a');
  navLinks.forEach(function (link) {
    link.addEventListener('click', toggleMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
